import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

import { computed, PropType } from 'vue';
import { TirPmButton, TirPmButtonVariantEnum, TirPmButtonSizeEnum } from 'tir-components';
import { CrossCompactIcon } from 'tir-style-system/icons/outline';
import { TaskViewElementEnum } from '@/components/tasks-kanban/enums';
import { OrderTaskModel, TaskColumnModel, TeammateModel } from '../../models';
import { TaskCard } from '../task-card';

// #region defineProps

export default /*#__PURE__*/_defineComponent({
  __name: 'task-order-li',
  props: {
  /**Юзер */
  user: { type: Object as PropType<TeammateModel> },
  /**Расположить статус в левой части таблицы */
  isStatusLeftBlock: { type: Boolean, default: false },
  /**Задача */
  task: {
    type: Object as PropType<OrderTaskModel>,
    required: true,
  },
  /**Колонки */
  columns: {
    type: Array as PropType<Array<TaskColumnModel>>,
    required: true,
  },
  /**Настройки видимости */
  viewSettings: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    required: true,
  },
  /**Загрузка при удалении */
  isLoadingDelete: {
    type: Boolean,
    default: false,
  },
  /**Доступ на редактирование всего списка очередности */
  fullChangeAccessOrder: {
    type: Boolean,
    default: false,
  },
},
  emits: ["remove", "openTaskDrawer"],
  setup(__props, { emit }) {

const props = __props;


// #endregion defineProps

// #region defineEmits


// #endregion defineEmits

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TaskCard), {
    shortInfoParameter: "",
    changeAccess: __props.task.ChangeAccess,
    user: __props.user,
    task: __props.task,
    columns: __props.columns,
    "view-settings": __props.viewSettings,
    isStatusLeftBlock: __props.isStatusLeftBlock,
    onOpenTaskDrawer: _cache[1] || (_cache[1] = ($event: any) => (emit('openTaskDrawer', $event)))
  }, {
    left: _withCtx(() => [
      _createElementVNode("div", null, [
        (__props.task.ChangeAccess || __props.task.ZmkType === 2)
          ? (_openBlock(), _createBlock(_unref(TirPmButton), {
              key: 0,
              class: "task-order-li__remove-button",
              variant: _unref(TirPmButtonVariantEnum).SecondaryState,
              size: _unref(TirPmButtonSizeEnum).Middle,
              "is-loading": __props.isLoadingDelete,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('remove', __props.task.Id)))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CrossCompactIcon), { class: "task-order-li__remove-button-icon" })
              ]),
              _: 1
            }, 8, ["variant", "size", "is-loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["changeAccess", "user", "task", "columns", "view-settings", "isStatusLeftBlock"]))
}
}

})